import { createInertiaApp } from "@inertiajs/react"
import { createElement } from "react"
import { createRoot } from "react-dom/client"

const pages = import.meta.glob("../components/**/*.{js,jsx}")

document.addEventListener("DOMContentLoaded", () => {
  createInertiaApp({
    resolve: (name) => {
      const mod = pages[`../components/${name}.jsx`] ?? pages[`../components/${name}.js`]
      return mod()
    },
    setup({ el, App, props }) {
      const root = createRoot(el)
      root.render(createElement(App, props))
    },
  })
})
